import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import PrivateRoutes from './routes/PrivateRoutes';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import ActionDashboard from './pages/LT/ActionDashboard/actionDashboard';
import ErrorPage from './pages/ErrorPage';
import LandingPage from './pages/LandingPage/LandingPage';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './auth/msalConfig';
import LoginPage from './pages/Login/LoginPage';
import ARDashboard from './pages/Ariba/ARDashboard';
import RiskDetail from './pages/Ariba/ARDashboard/RiskDetail';
import MaterialDetails from './pages/Ariba/ARDashboard/MaterialDetails';
import ForecastCollab from './pages/Ariba/ARForecast/ForecastCollabCPS';
import ForecastCollabDPS from './pages/Ariba/ARForecast/ForecastCollabDPS';
import ForecastCollabCPS from './pages/Ariba/ARForecast/ForecastCollabCPS';
import Reporting from './pages/Ariba/ARReporting/Reporting';
import AdminPage from './pages/Ariba/Admin/AdminPage';
import ParamConfig from './pages/Ariba/ParameterConfiguration/ParamConfig';
import SapIbpSyncStatus from './pages/Ariba/SapIbpSyncStatus/SapIbpSyncStatus';
import S4PrSyncStatus from './pages/Ariba/S4PrSyncStatus/S4PrSyncStatus';
import SupplierDetails from './pages/Ariba/ARDashboard/SupplierDetails/SuplierDetails';
import TicketSummary from './pages/Ariba/TicketSummary';
import { EventType } from "@azure/msal-browser";
const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

// after await msalInstance.initialize();
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

document.title = process.env.REACT_APP_PAGE_TITLE;

const observerError = "ResizeObserver loop completed with undelivered notifications.";
window.addEventListener("error", (e) => {
  if (e.message === observerError) {
    e.stopImmediatePropagation();
  }
});

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Provider store={store}>
        <App />
      </Provider>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: "login",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <LoginPage />,
          },
        ],
      },
      
      {
        path: "dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ARDashboard />,
          },
          {
            path:":risk",
            element: <RiskDetail />,
          }
          ,
          {
            path: "material/:materialId/:plantId",
            element: <MaterialDetails />,
          },
          {
            path:"material/:materialId/:plantId/supplier/:supplierId/:supplierName?",
            element: <SupplierDetails />,
          }
        ],
      },
      {
        path: "forecastCollab-cps",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ForecastCollabCPS />,
          },
        ],
      },
      {
        path: "forecastCollab-dps",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ForecastCollabDPS />,
          },
        ],
      },
      {
        path: "reporting",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <Reporting />,
          },
        ],
      },
      {
        path: "admin",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AdminPage />,
          },
        ],
      },
      {
        path:"sap-ibp-sync-status",
        element:<PrivateRoutes />,
        children:[
          {
            path:"",
            element:<SapIbpSyncStatus />,
          }
        ]
      },
       
      {
        path:"parameter-configuration",
        element:<PrivateRoutes />,
        children:[
          {
            path:"",
            element:<ParamConfig />,
          }
        ]
      },
      {
        path:"sc-ticketsummary",
        element:<PrivateRoutes />,
        children:[
          {
            path:"",
            element:<TicketSummary />,
          }
        ]
      }
    ],
  },

]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <RouterProvider router={router} />
    </MsalProvider>
  </React.StrictMode>
);
reportWebVitals();
